

$(document).ready(function(){

    $('.bundle_item').on('change', function(){
        var price = $(this).data('price');
        var compare = $(this).data('compare');
        var discount = $(this).data('discount');
        var variant_id = $(this).val();
        var plan = $('.input_plan:checked').val();
        var plan_id = $('.select-delivery-time option:selected').val();
        var save;

        if(compare > 0) {
            save = compare - discount;
        }else{
            save = price - discount;
        }
        priceUpdate(price, compare, discount, variant_id, plan, plan_id)
    })

    $('.input_plan').on('change', function(){
        var type = $('.default_variant').val();
        var input;
        if(type == 1){
            input = $('.bundle_item:checked');
        }else{
            input = $('.default_variant');
        }
        var price = input.data('price');
        var compare = input.data('compare');
        var discount =input.data('discount');
        var variant_id = input.val();
        var plan = $(this).val();
        var plan_id = $('.select-delivery-time option:selected').val();
        var save;

        if(compare > 0) {
            save = compare - discount;
        }else{
            save = price - discount;
        }
        priceUpdate(price, compare, discount, variant_id, plan, plan_id)
    })

    $('.select-delivery-time').on('change', function(){
       var id = $(this).val();
       $('#selling_plan').val(id);
    })

    // priceUpdate();

    var type = $('.default_variant').val();
    var checkPrice = $('.bundle_item:checked').data('price');
    var checkDiscount = $('.bundle_item:checked').data('discount');
    var checkCom = $('.bundle_item:checked').data('compare');

    var checkId = $('.bundle_item:checked').val();

    if(checkCom < 0) {
        checkCom = checkPrice;
    }
    if(checkDiscount == '0.0') {
        checkDiscount = checkPrice;
    }

    console.log('checkDiscount ' + checkDiscount);

    var defaultPrice = $('.default_variant').data('price');
    var defaultCom = $('.default_variant').data('compare');
    var defaultDiscount = $('.default_variant').data('discount');
    var defaultId = $('.default_variant').data('vid');

    if(defaultCom < 0) {
        defaultCom = defaultPrice;
    }

    checkCom = parseFloat(checkCom);
    checkCom = checkCom.toFixed(2);
    checkCom = checkCom.toString().replace('.', ',');

    defaultCom = parseFloat(defaultCom);
    defaultCom = defaultCom.toFixed(2);
    defaultCom = defaultCom.toString().replace('.', ',');

    // console.log('checkCom ' +checkCom)
    // console.log('defaultCom ' +defaultCom)

    if(type == 1) {
        $('.subs_price, #winner_text').text(currency + checkDiscount);
        $('#product_id').val(checkId);
        if(checkCom == '0,00') {
            $('.onetime_prev_price').hide()
        }else{
            $('.onetime_prev_price').show().text(currency + checkCom);
        }
      
    }else{
        $('.subs_price, #winner_text').text(currency + defaultDiscount);
        $('#product_id').val(defaultId);
        if(checkCom == '0,00') {
            $('.onetime_prev_price').hide()
        }else{
            $('.onetime_prev_price').show().text(currency + defaultCom);
        }
         
    }


})

function  priceUpdate(price, compare, discount, variant_id, plan, plan_id) {
    discount = parseFloat(discount);
    discount = discount.toFixed(2);
    discount = discount.toString().replace('.', ',');

    price = parseFloat(price);
    price = price.toFixed(2);
    price = price.toString().replace('.', ',');
    com = compare;
    
    $('.subs_price').text(currency + discount);
    
    if(com > 0) {
        compare = parseFloat(compare);
        compare = compare.toFixed(2);
        compare = compare.toString().replace('.', ',');
        $('.prev_price').text(currency + compare);
        $('.onetime_prev_price').show().text(currency + compare);
    }else{
        $('.prev_price').text(currency + price);
        $('.onetime_prev_price').hide();
    }
    $('.onetime_reg').text(currency + price);
    $('#product_id').val(variant_id);

    if(plan == 1) {
        $('#selling_plan').val(plan_id);
        $('#winner_text').text(currency + discount); 
    }else{
        $('#selling_plan').val('');
        $('#winner_text').text(currency + price);
    }

    updateComparePrice();
    
}


$(document).ready(function(){
    $('.addToCart').on('click', function(){
        let plan = $('.input_plan:checked').val();
        var items = [];
        var mainProductId = $('#product_id').val();
        var mainPlan = $('#delivery_time').val();

        items.push({
            id: mainProductId,
            quantity: 1,
            ...(plan == 1 && { selling_plan: mainPlan })
        });

        if(plan == 1) {
            $('.gift-item').each(function () {
                let giftId = $(this).data('id');
                // var productId = $(this).val();
                // var quantity = parseInt($(this).data('qty'));
                items.push({
                    id: giftId,
                    quantity: 1,
                    
                });
            });    
        }
        
        $.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: { items: items },
			dataType: 'json',
			success: function (response) {
				console.log('Item(s) added to cart successfully!');
			},
			error: function (err) {
				console.error('Error:', err);
				
			}
		});
    })
})

function updateComparePrice() {
    // var $mainBlock = $('.subscription-fee');

    var type = $('.default_variant').val();
    var $mainBlock;
    if(type == 1){
        $mainBlock = $('.bundle_item:checked');
    }else{
        $mainBlock = $('.default_variant');
    }
    var basePrice = parseFloat($mainBlock.data('price'));
    var comparePrice = parseFloat($mainBlock.data('compare'));
    var discountPrice = parseFloat($mainBlock.data('discount'));

    var mainTotal = (comparePrice > 0) ? comparePrice : basePrice;

    // Total gift item prices
    var giftTotal = 0;
    $('.gift-item').each(function () {
        var giftPrice = parseFloat($(this).data('price'));
        if (!isNaN(giftPrice)) {
            giftTotal += giftPrice;
        }
    });

    var finalComparePrice = mainTotal + giftTotal;

    // Euro formatter
    function formatEuro(value) {
        return currency + value.toFixed(2).replace('.', ',');
    }

    var discountPercent = 0;
    if (finalComparePrice > 0) {
        discountPercent = ((finalComparePrice - discountPrice) / finalComparePrice) * 100;
    }

    var save = (finalComparePrice - discountPrice).toFixed();

    function formatPercent(value) {
        return Math.round(value) + '%';
    }

    $('.prev_price').text(formatEuro(finalComparePrice));
    $('.subscription-savings').text( currency  + save + ' KORTING');
}

// Call it on page load
$(document).ready(function () {
    updateComparePrice();
});
